import React, { useState } from 'react';
import { FaTimes, FaLock, FaEye, FaEyeSlash, FaSave } from 'react-icons/fa';
import Loader from './Loader';
import './ChangePasswordModal.css';

function ChangePasswordModal({ onClose, changePassword, onSuccess }) {
    const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
    const [show, setShow] = useState({ current: false, next: false, confirm: false });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const update = (key, value) => {
        setForm(prev => ({ ...prev, [key]: value }));
        setError('');
        setSuccess('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (form.newPassword !== form.confirmPassword) {
            setError('New password and confirmation do not match.');
            return;
        }
        if (form.newPassword.length < 6) {
            setError('New password must be at least 6 characters.');
            return;
        }
        if (form.currentPassword === form.newPassword) {
            setError('New password must be different from the current one.');
            return;
        }
        setSubmitting(true);
        try {
            await changePassword({
                currentPassword: form.currentPassword,
                newPassword: form.newPassword
            });
            setSuccess('Password updated successfully.');
            setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
            if (onSuccess) onSuccess();
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to update password.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal change-password-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2><FaLock /> Change Password</h2>
                    <button className="modal-close" onClick={onClose} aria-label="Close"><FaTimes /></button>
                </div>

                {error && <div className="cp-error">{error}</div>}
                {success && <div className="cp-success">{success}</div>}

                <form onSubmit={handleSubmit} className="cp-form">
                    <div className="form-group">
                        <label>Current Password</label>
                        <div className="cp-input-wrap">
                            <input
                                type={show.current ? 'text' : 'password'}
                                value={form.currentPassword}
                                onChange={e => update('currentPassword', e.target.value)}
                                required
                                autoComplete="current-password"
                            />
                            <button type="button" className="cp-toggle" onClick={() => setShow(s => ({ ...s, current: !s.current }))} aria-label="Toggle password visibility">
                                {show.current ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>New Password</label>
                        <div className="cp-input-wrap">
                            <input
                                type={show.next ? 'text' : 'password'}
                                value={form.newPassword}
                                onChange={e => update('newPassword', e.target.value)}
                                required
                                minLength={6}
                                autoComplete="new-password"
                                placeholder="At least 6 characters"
                            />
                            <button type="button" className="cp-toggle" onClick={() => setShow(s => ({ ...s, next: !s.next }))} aria-label="Toggle password visibility">
                                {show.next ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Confirm New Password</label>
                        <div className="cp-input-wrap">
                            <input
                                type={show.confirm ? 'text' : 'password'}
                                value={form.confirmPassword}
                                onChange={e => update('confirmPassword', e.target.value)}
                                required
                                minLength={6}
                                autoComplete="new-password"
                            />
                            <button type="button" className="cp-toggle" onClick={() => setShow(s => ({ ...s, confirm: !s.confirm }))} aria-label="Toggle password visibility">
                                {show.confirm ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="cp-submit-btn" disabled={submitting}>
                        {submitting ? <Loader inline label="Updating" /> : <><FaSave /> Update Password</>}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default ChangePasswordModal;
